module.exports = {
	"textures": [
		{
			"image": "BallEnd.png",
			"format": "RGBA8888",
			"size": {
				"w": 32,
				"h": 32
			},
			"scale": 1,
			"frames": [
				{
					"filename": "0.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 247,
						"y": 121,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 259,
						"y": 122,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 1,
						"y": 15,
						"w": 12,
						"h": 12
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:87b4827b70950e424ec6531ffc2a6c2f:c4fa0f4e9ab20ae526deec46a5a45776:923cf1a062b4fcbcf7acb4c313e9fe6a$"
	}
}
;